export default {
  black: '#000',
  white: '#fff',
  blue: '#0060fb',
  project: {
    default: '#f5f5f5',
    hover: '#c5c5c5',
  },
  tag: {
    normal: '#000',
    hover: '#373737',
    active: '#000',
    disable: '#c5c5c5',
  },
  exLink: {
    normal: '#0060fb',
    hover: '#5495ff',
    active: '#0048bc',
    disable: ' #c5c5c5',
  },
  link: {
    normal: '#0060fb',
    hover: '#65a0ff',
    active: '#c1c1c1',
    visited: '#0042ad',
  },
  messages: {
    success: '#3fd0ab',
    error: '#f56f4c',
  },
  form: {
    placeholder: '#cfcfcf',
    text: '#000',
  },
};
